module.exports = __webpack_public_path__ + "img/id.73218b16.jpg";